const map = {
	"./add_recording.svg": 67307,
	"./archive-workspace.svg": 10404,
	"./archive.svg": 93544,
	"./archive_icon.svg": 37056,
	"./arrow-down-light_icon.svg": 15423,
	"./arrow-down_icon.svg": 82062,
	"./arrow-left.svg": 56145,
	"./arrow-right_icon.svg": 28500,
	"./arrow-up.svg": 49897,
	"./arrow_back.svg": 67993,
	"./article_icon.svg": 73504,
	"./assign-tags.svg": 12649,
	"./burger-menu.svg": 95051,
	"./carbon_copy.svg": 53763,
	"./chat.svg": 71660,
	"./check.svg": 14414,
	"./checkmark.svg": 82505,
	"./close-round.svg": 5029,
	"./copy.svg": 22541,
	"./copy_icon.svg": 64155,
	"./delete-fill.svg": 34299,
	"./delete-filled.svg": 5624,
	"./delete.svg": 65863,
	"./discard-changes.svg": 77604,
	"./download.svg": 92446,
	"./drop_arrow.svg": 6427,
	"./edit.svg": 69338,
	"./error.svg": 56660,
	"./group-icon.svg": 76643,
	"./integrations/bitbucket.svg": 87729,
	"./integrations/confluence.svg": 31188,
	"./integrations/gdocs.svg": 25908,
	"./integrations/github.svg": 44263,
	"./link.svg": 86342,
	"./loader.svg": 90615,
	"./lock_icon.svg": 74321,
	"./more-vert_icon.svg": 28641,
	"./note.svg": 9274,
	"./notification-off.svg": 59891,
	"./pdf.svg": 39392,
	"./pencil.svg": 74709,
	"./pencil_4.svg": 24660,
	"./pin.svg": 70755,
	"./play-circle.svg": 86121,
	"./playbackspeed.svg": 63038,
	"./player-cursor.svg": 85648,
	"./plus_icon.svg": 30342,
	"./point.svg": 61796,
	"./priority-high.svg": 47627,
	"./reorder-icon_active.svg": 93528,
	"./reorder-icon_inactive.svg": 90129,
	"./reorder_articles.svg": 38163,
	"./reset-forward.svg": 85791,
	"./search.svg": 12054,
	"./send-light.svg": 10603,
	"./send.svg": 61824,
	"./share_icon.svg": 53277,
	"./shared_outside.svg": 2053,
	"./show-archive-article.svg": 97969,
	"./snap-logo.svg": 63874,
	"./sort.svg": 57774,
	"./speech-icon.svg": 31226,
	"./sub-article.svg": 26037,
	"./swap-horiz.svg": 62878,
	"./transfer.svg": 65683,
	"./trash.svg": 90008,
	"./unarchive-workspace.svg": 76467,
	"./unarchive_icon.svg": 55341,
	"./undo.svg": 6240,
	"./unlock-icon.svg": 78564,
	"./unlock.svg": 69818,
	"./unlock_icon.svg": 98190,
	"./unpin.svg": 84672,
	"./user-active_icon.svg": 61218,
	"./user-profile-icon.svg": 40187,
	"./user_icon.svg": 29497,
	"./version-history.svg": 60825,
	"./volume_max.svg": 67055,
	"./volume_min.svg": 25737,
	"./volume_off.svg": 50930
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19832;